import React, { useEffect } from 'react';
import Modal from 'components/UI/Modal';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import { pushCustomEvent } from 'utils/analytics';
import { observer, pricingCalculator as store } from 'store';

function StepsModal({
  isOpen,
  closeModalCallback,
  resetFirstStep,
  id,
  button: businessNeed,
  steps,
}) {
  const { currentStep } = store;

  useEffect(() => {
    if (isOpen) {
      const modalContainerId = 'modal';
      const handleCalculatorBodyClick = () => {
        pushCustomEvent('pricingMobile', { action: `click-on-${currentStep}-step`, label: id });
      };
      const modal = document.getElementById(modalContainerId);

      modal.addEventListener('click', handleCalculatorBodyClick);
      return () => modal.removeEventListener('click', handleCalculatorBodyClick);
    }
  }, [isOpen, currentStep]);

  return (
    <Modal
      isOpen={isOpen}
      closeModalCallback={closeModalCallback}
      animation="right"
      theme="mobilePricing"
      containerMod="fullScreenMobile"
      contentMod="fullScreenMobile"
      closeButton={false}
    >
      {onClose => (
        <>
          <ModalHeader lastStep={steps?.length + 1} handleClose={onClose} />
          <ModalContent id={id} steps={steps} onClose={onClose} resetFirstStep={resetFirstStep} />
          <ModalFooter id={id} businessNeed={businessNeed} steps={steps} handleClose={onClose} />
        </>
      )}
    </Modal>
  );
}

export default observer(StepsModal);
